import classNames from "classnames";
import React from "react";

type Props = {
  text: string;
  className?: string;
};

const Title = ({ text, className = "pb-22" }: Props) => (
  <h1 className={classNames(className, "text-white text-4xl")}>{text}</h1>
);

export default Title;
